/**
 * Wartości opcji przychodzą z API jako liczby, a Formik trzyma je jako ciągi (tak zapisuje je
 * `Select`, tak samo wracają z adresu URL w listingach). Porównanie identycznością gubiło wtedy
 * zaznaczenie, więc wszystkie kontrolki wyboru porównują wartości w jednej, tekstowej postaci.
 */
export function isSameOptionValue(value: unknown, optionValue: unknown): boolean {
    if (
        value === null ||
        value === undefined ||
        optionValue === null ||
        optionValue === undefined
    ) {
        return false;
    }

    return String(value) === String(optionValue);
}
